import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ModalComponent } from '../../../shared/modal/modal.component';
import { DropdownInputComponent } from '../../../shared/dropdown-input/dropdown-input.component';
import {
  AutosuggestDropdownInputComponent
} from '../../../shared/autosuggest-dropdown-input/autosuggest-dropdown-input.component';
import { Subscription } from 'rxjs';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ExpenseCategoryItem } from '../../../core/models/expense-category-list.model';
import { PatientDetail } from '../../../core/models/patient-detail.model';
import { TrialDetail } from '../../../core/models/trial-detail.model';
import { ActivatedRoute } from '@angular/router';
import { TemplateService } from '../../../core/services/template.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { ExpenseService } from '../../../core/services/expense.service';
import { PatientService } from '../../../core/services/patient.service';
import { LogHelper } from '../../../core/helpers/log.helper';
import { TrialAutocompleteComponent } from '../../../shared/trial-autocomplete/trial-autocomplete.component';
import { TrialAutocomplete } from '../../../shared/trial-autocomplete/trial-autocomplete.model';
import { Currencies } from 'app/core/constants/currency';
import { StringHelper } from "../../../core/helpers/string-helper";
import { NumberHelper } from "../../../core/helpers/number.helper";
import { ExchangeRateRequest } from 'app/core/models/exchange-rate.model';
import { ExchangeRateService } from 'app/core/services/exchange-rate.service';
import { InputCurrencyComponent } from 'app/shared/input-currency/input-currency.component';
import { ExpenseClaimPaymentMethod, ExpenseSubCategory } from 'app/core/models/expense.model';
import { TrialService } from "../../../core/services/trial.service";
import { ExpenseClaimDetails } from "../../../core/models/expense-claim-details.model";
import { FileAttachment } from 'app/shared/shared.model';
import { HttpClient } from "@angular/common/http";
import moment from 'moment';
import { SelectOption } from 'app/core/models/select-option.model';
import { enumToText } from 'app/core/helpers/enum-to-text.function';

@Component({
  selector: 'app-duplicate-expense-modal',
  templateUrl: './duplicate-expense-modal.component.html',
  styleUrls: ['./duplicate-expense-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DuplicateExpenseModalComponent implements OnInit, AfterViewInit {
  @ViewChild('trialAutocomplete') trialAutocomplete: TrialAutocompleteComponent;
  @ViewChild('modal') modal: ModalComponent;
  @ViewChild('distanceUnitSelect') distanceUnitSelect: DropdownInputComponent;
  @ViewChild('currencySelect') currencySelect: AutosuggestDropdownInputComponent;
  @ViewChild('categorySelect') categorySelect: DropdownInputComponent;
  @ViewChild('visitSelect') visitSelect: DropdownInputComponent;
  @ViewChild('uploadImageInput') uploadImageInput: ElementRef;
  @ViewChild('removePhotoModal') removePhotoModal: ModalComponent;
  @ViewChild('preloadConfirmModal') preloadConfirmModal: ModalComponent;
  @ViewChild('amountQuotedBCControl') amountQuotedBCControl: InputCurrencyComponent;
  @ViewChild('paymentMethodSelect') paymentMethodSelect: DropdownInputComponent;

  @Output() cloned = new EventEmitter();

  overridePreloadPaymentMethod = false;

  //FX Rate
  transformedFxRateForm: UntypedFormGroup;
  transformedCurrencyProcessing: boolean = false;
  showFxTransformError: boolean = false;
  baseCurrency: string = '';

  //Expense Claim
  attachments: FileAttachment[] = [];
  uploadedImageFilenames: string[] = [];
  imagesUploadedSubscription: Subscription;
  imageUploadedEvent = new EventEmitter<string[]>();
  removePhotoAtIndex = null;
  isPreloadRedemption = false;

  form: UntypedFormGroup;
  distanceUnitOptions: { value: string; text: string }[] = [];
  currencyOptions: { value: string; text: string }[] = [];
  allVisitOptions: { value: string; text: string; meta?: any }[] = [];
  visitOptions: { value: string; text: string }[] = [];
  showNonVisits = false;
  categoryOptions: { value: string; text: string }[] = [];
  expenseId: string;
  categories: ExpenseCategoryItem[] = [];
  selectedCategory = new ExpenseCategoryItem('', '', '', '', false, null);
  isFormProcessing = false;
  returnTo: string;
  patient: PatientDetail;
  trial: TrialDetail;
  numberHelper = NumberHelper;
  ExpenseSubCategory = ExpenseSubCategory;
  expenseClaim: ExpenseClaimDetails;
  sourceExpenseClaimId: string;
  patientId: string;
  preparingClaim = true;
  includeAttachments = true;
  paymentMethodOptions: SelectOption[] = [
      {
        value: ExpenseClaimPaymentMethod.ManualBankTransfer.toString(),
        text: enumToText(ExpenseClaimPaymentMethod, ExpenseClaimPaymentMethod.ManualBankTransfer)
      },
      {
        value: ExpenseClaimPaymentMethod.CaxtonCard.toString(),
        text: enumToText(ExpenseClaimPaymentMethod, ExpenseClaimPaymentMethod.CaxtonCard)
      },
      {
        value: ExpenseClaimPaymentMethod.CaxtonAutomatedBankTransfer.toString(),
        text: enumToText(ExpenseClaimPaymentMethod, ExpenseClaimPaymentMethod.CaxtonAutomatedBankTransfer)
      },
      {
        value: ExpenseClaimPaymentMethod.NmibleCard.toString(),
        text: enumToText(ExpenseClaimPaymentMethod, ExpenseClaimPaymentMethod.NmibleCard)
      },
      {
        value: ExpenseClaimPaymentMethod.NmibleAutomatedBankTransfer.toString(),
        text: enumToText(ExpenseClaimPaymentMethod, ExpenseClaimPaymentMethod.NmibleAutomatedBankTransfer)
      }
    ];

  get hasNonVisits(): boolean {
    return this.allVisitOptions.some(v => v.meta?.nonVisit);
  }

  toggleNonVisits() {
    this.showNonVisits = !this.showNonVisits;
    this.filterVisitOptions();
    this.form.patchValue({ visitId: '' });
    setTimeout(() => {
      this.visitSelect.reset();
    });
  }

  private filterVisitOptions() {
    this.visitOptions = this.allVisitOptions.filter(v => this.showNonVisits ? v.meta?.nonVisit === true : !v.meta?.nonVisit);
  }

  get canTransformRate(): boolean {
    let baseCurrency = this.patient.trialBaseCurrency;
    let amount = this.form.get('amount').value;
    let currency = this.form.get('currency').value;
    return baseCurrency !== '' && baseCurrency !== null && baseCurrency !== undefined
      && amount !== '' && amount !== null && amount !== undefined
      && currency !== '' && currency !== null && currency !== undefined;
  }

  constructor(
    private readonly templateService: TemplateService,
    private readonly alertService: AlertService,
    private readonly expenseService: ExpenseService,
    private readonly exchangeRateService: ExchangeRateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly patientService: PatientService,
    private readonly trialService: TrialService,
    private readonly http: HttpClient) {
  }

  ngOnInit() {
    this.templateService.showHeader();

    // Populate distance units drop down
    this.distanceUnitOptions.push({ value: 'Miles', text: 'Miles' });
    this.distanceUnitOptions.push({ value: 'Kilometers', text: 'Kilometers' });

    // Populate currencies drop down
    for (const currency of Currencies.all()) {
      this.currencyOptions.push({ value: currency.cc, text: currency.cc });
    }

    this.form = new UntypedFormGroup({
      trialId: new UntypedFormControl('', Validators.required),
      trialName: new UntypedFormControl(''),
      patientId: new UntypedFormControl(''),
      patientName: new UntypedFormControl({ value: '', disabled: this.returnTo === 'patient' }),
      visitId: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
      visitName: new UntypedFormControl(''),
      categoryId: new UntypedFormControl('', Validators.required),
      subCategoryId: new UntypedFormControl(''),
      currency: new UntypedFormControl(''),
      amount: new UntypedFormControl(''),
      distanceAmount: new UntypedFormControl(''),
      distanceUnit: new UntypedFormControl(''),
      fullyReconciled: new UntypedFormControl(false),
      claimFormId: new UntypedFormControl('', Validators.maxLength(50)),
      claimFormUrl: new UntypedFormControl('', Validators.maxLength(400)),
      claimFormDate: new UntypedFormControl(null),
      notes: new UntypedFormControl('', Validators.maxLength(1000)),
      onHold: new UntypedFormControl(false),
      overspendApproved: new UntypedFormControl(false),
      paymentMethod: new UntypedFormControl(null)
    });

    this.transformedFxRateForm = new UntypedFormGroup({
      transformedAmount: new UntypedFormControl(''),
      transformedCurrency: new UntypedFormControl({ value: '', disabled: true }),
    });

    this.form.get('categoryId').valueChanges.subscribe(value => {
      this.setSelectedCategory(value);
    });
  }

  ngAfterViewInit() {
    this.activatedRoute.params.subscribe(params => {
      this.expenseId = params.id;
    });

    this.initFormChangeSubscriptions();
  }

  initFormChangeSubscriptions() {
    this.form.get('patientId').valueChanges.subscribe((patientId: string) => {
      this.onHandlePatientChanged(patientId);
    });

    this.trialAutocomplete.valueChanged.subscribe((option: TrialAutocomplete) => {
      // Set the trial
      this.loadPatientTrial(this.form.get('patientId').value, option.id).then(() => {
        this.loadPatientVisits(this.form.get('patientId').value, option.id).then(() => {
          this.initialiseFormWithClaim(this.expenseClaim);
        });
      });

    });
  }

  distanceAmountValidator(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value;
    if (value === undefined || value === null || value === '') {
      return { required: true };
    }

    const amount = +control.value;
    if (amount > 0 && Number.isInteger(amount)) {
      return null;
    }

    return { invalid: true };
  }

  onHandlePatientChanged(patientId: string) {
    if (!patientId || patientId === this.patientId) {
      return;
    }

    this.patientId = patientId;

    this.form.reset();
    if (this.categorySelect !== undefined) {
      this.categorySelect.reset();
      this.selectedCategory = new ExpenseCategoryItem('', '', '', '', false, null);
    }
    if (this.currencySelect !== undefined && this.currencySelect !== null) {
      this.currencySelect.onClear();
    }
    if (this.distanceUnitSelect !== undefined) {
      this.distanceUnitSelect.reset();
    }
    if (this.visitSelect !== undefined) {
      this.visitSelect.reset();
    }

    // Load patient details
    this.trialAutocomplete.setPatientId(patientId);
    this.loadPatientDetails(patientId);
  }

  resetForm(): void {
    // Using form.reset() breaks the autocomplete
    this.form.patchValue({
      patientId: '',
      patientName: '',
      visitId: '',
      visitName: '',
      trialId: '',
      categoryId: '',
      subCategoryId: '',
      currency: '',
      amount: '',
      distanceAmount: '',
      distanceUnit: '',
      notes: '',
      fullyReconciled: false,
      claimFormId: '',
      claimFormUrl: '',
      claimFormDate: null,
    });

    this.trial = undefined;
    this.patientId = undefined;
    this.patient = undefined;

    this.uploadedImageFilenames = [];
    this.uploadImageInput.nativeElement.value = '';
    this.attachments = [];
    this.allVisitOptions = [];
    this.showNonVisits = false;

    this.form.get('notes').reset();

    if (this.trialAutocomplete)
      this.trialAutocomplete.reset();

    if (this.visitSelect)
      this.visitSelect.reset();

    if (this.categorySelect) {
      this.categorySelect.reset();
      this.selectedCategory = new ExpenseCategoryItem('', '', '', '', false, null);
    }

    if (this.distanceUnitSelect)
      this.distanceUnitSelect.reset();

    if (this.currencySelect)
      this.currencySelect.onClear();

    if (this.trialAutocomplete)
      this.trialAutocomplete.reset();

  }

  show(expenseClaimId: string, includeAttachments: boolean = true): void {
    this.preparingClaim = true;
    this.sourceExpenseClaimId = expenseClaimId;
    this.isPreloadRedemption = false;
    this.includeAttachments = includeAttachments;
    this.resetForm();
    this.patient = null;
    this.patientId = null;
    this.selectedCategory = new ExpenseCategoryItem('', '', '', '', false, null);
    this.modal.show();
    this.initFormChangeSubscriptions();

    this.loadExpenseClaim(expenseClaimId);
  }

  private initialiseFormWithClaim(claim: ExpenseClaimDetails) {
    if (claim.trialBaseCurrency !== null && claim.trialBaseCurrency !== undefined) {
      this.transformedFxRateForm.patchValue({ transformedCurrency: claim.trialBaseCurrency });
    }
    this.amountQuotedBCControl.setCurrency(claim.trialBaseCurrency);
    //this.showTransformedCurrency = true;

    // Set other values on the form
    this.form.patchValue({
      trialId: claim.trialId,
      subCategoryId: claim.subCategory,
      currency: claim.currency,
      amount: claim.amount !== null ? claim.amount.toString() : '',
      distanceAmount: claim.distanceAmount,
      distanceUnit: claim.distanceUnit,
      paymentMethod: claim.paymentMethod,
      onHold: claim.onHold,
      overspendApproved: claim.overspendApproved,
      notes: claim.notes,
      fullyReconciled: claim.fullyReconciled,
      claimFormId: claim.claimFormId,
      claimFormDate: claim.claimFormDate,
      claimFormUrl: claim.claimFormUrl
    });

    if (claim.currency)
      this.currencySelect.setSelectedOption(claim.currency);

    if (claim.distanceUnit) {
      const distanceIsInKilometers = claim.distanceUnit?.toLowerCase() === 'kilometers' || claim.distanceUnit?.toLowerCase() === 'km';
      this.distanceUnitSelect.setValue(distanceIsInKilometers ? 'Kilometers' : 'Miles');
    }

    if (this.paymentMethodSelect) {
      this.paymentMethodSelect.setValue(claim.paymentMethod !== null ? claim.paymentMethod.toString() : '0');
      this.currencySelect.setSelectedOption(claim.currency);
    }
  }

  private loadExpenseClaim(expenseClaimId: string): void {
    this.expenseService.retrieveExpenseClaim(expenseClaimId).subscribe({
      next: claim => {
        this.expenseClaim = claim;

        this.form.patchValue({ patientId: claim.patientId });

        // Set the trial
        this.loadPatientTrial(claim.patientId, claim.trialId).then(() => {
          // Once the visit is loaded, load the trial
          this.loadPatientVisits(claim.patientId, claim.trialId).then(() => {
            // If the expense's visit is a non-visit, switch to showing non-visits
            const visitOption = this.allVisitOptions.find(v => v.value === claim.visitId);
            if (visitOption?.meta?.nonVisit) {
              this.showNonVisits = true;
              this.filterVisitOptions();
            }

            // Set visit - we need a delay to make sure the dropdown is visible
            setTimeout(() => {
              this.form.patchValue({ visitId: claim.visitId })
              this.visitSelect.setValue(claim.visitId);

              // Set the expense category
              this.form.patchValue({ expenseClaimId: claim.expenseCategoryId });
              this.categorySelect.setValue(claim.expenseCategoryId);

              this.initialiseFormWithClaim(claim);
            }, 200);

            // Download receipts and add them to the page – only if requested
            if (
              this.includeAttachments &&
              claim.imageUrls &&
              claim.imageUrls.length
            ) {
              this.downloadReceipts(
                claim.imageUrls.map((r) => r.imageUrl),
              ).then((attachments) => {
              this.attachments = attachments;
              this.preparingClaim = false;
            });
            } else {
              this.attachments = [];
              this.preparingClaim = false;
            }
          });
        });
      },
      error: (err) => {
        this.alertService.showErrorAlert(err);
      }
    });
  }

  private async downloadReceipts(receiptUrls: string[]): Promise<FileAttachment[]> {
    const attachments: FileAttachment[] = [];

    // Map over the array of URLs and download each file
    const downloadPromises = receiptUrls.map(async (url, index) => {
      try {
        // Fetch file as Blob
        const response = await this.http.get(url, { responseType: 'blob' }).toPromise();

        // Extract filename and extension
        const filename = this.getFileNameFromURL(url) || `file_${index + 1}`;
        const extension = this.getFileExtension(filename);

        // Push to the attachments array
        attachments.push({
          data: response,
          filename: filename,
          fileUrl: url,
          extension: extension
        });
      } catch (error) {
        console.error(`Error downloading file from URL: ${url}`, error);
      }
    });

    // Wait for all downloads to complete
    await Promise.all(downloadPromises);

    return attachments;
  }

  private getFileExtension(filename: string): string {
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop() || '' : '';
  }

  private getFileNameFromURL(url: string): string | null {
    const match = url.match(/\/([^\/?#]+)(\?.*)?$/);
    return match ? match[1] : null;
  }

  disableScrollWheel(event: WheelEvent): void {
    event.preventDefault();
  }

  hide(): void {
    this.overridePreloadPaymentMethod = false;
    this.modal.hide();
  }

  /**
   * Loads the trial associated with the expense claim, and also listens for changes to the trial and starts
   * the process of updating visits and categories
   * @param trialId
   */
  loadTrial_NOTUSED(trialId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.trialService.retrieveTrial(trialId).subscribe({
        next: trial => {
          this.trial = trial;
          this.trialAutocomplete.setInitialValue(trial.id, trial.code);

          resolve();
        },
        error: err => {
          reject(err);
        }
      });
    });
  }


  // Load and populate visits select
  loadVisits(trialId: string): Promise<void> {
    this.visitSelect.reset();
    this.allVisitOptions = [];
    this.showNonVisits = false;

    return new Promise((resolve, reject) => {
      this.patientService.retrievePatientVisitsForTrial(this.form.get('patientId').value, trialId).subscribe({
        next: visits => {
          for (const visit of visits) {
            this.allVisitOptions.push({ value: visit.id, text: visit.visitDateAndTitle(), meta: { nonVisit: visit.nonVisit } });
          }
          this.filterVisitOptions();

          resolve();
        },
        error: err => {
          this.alertService.showErrorAlert(err);

          reject(err);
        }
      });
    });
  }

  setSelectedCategory(expenseCategoryId: string) {
    for (const category of this.categories.filter(c => c.id === expenseCategoryId)) {
      this.selectedCategory = category;

      if (category.type === 'Distance') {
        this.form.get('amount').setValidators(null);
        this.form.get('currency').setValidators(null);
        this.form.get('amount').setErrors({ required: false });
        this.form.get('currency').setErrors({ required: false });
        this.form.get('amount').reset();
        this.form.get('currency').reset();
        this.currencySelect.onClear();

        this.form.get('distanceAmount').setValidators(this.distanceAmountValidator);
        this.form.get('distanceAmount').setErrors({ required: true });

        this.form.get('distanceUnit').setValidators([Validators.required]);
        this.form.get('distanceUnit').setErrors({ required: true });
      }

      if (category.type === 'Value') {
        this.form.get('currency').setValidators([Validators.required]);
        this.form.get('amount').setValidators(this.amountValidator);
        this.form.get('distanceAmount').setValidators(null);
        this.form.get('distanceUnit').setValidators(null);
        this.form.get('distanceAmount').setErrors({ required: false });
        this.form.get('distanceUnit').setErrors({ required: false });
        this.form.get('distanceUnit').reset();
        this.form.get('distanceAmount').reset();

        this.form.get('currency').updateValueAndValidity();
        this.form.get('amount').updateValueAndValidity();
        this.prepareAmountBCControl();
      }

      // Update validation on the form depending on whether 'other' is selected as a category
      if (category.internalType.toLowerCase() === 'other') {
        this.form.patchValue({ subCategoryId: 0 });
        this.form.get('subCategoryId').setValidators([Validators.required]);
        this.form.get('subCategoryId').setErrors({ required: true });
      } else {
        this.form.get('subCategoryId').setValidators(null);
        this.form.get('subCategoryId').setErrors(null);
        this.form.patchValue({ subCategoryId: '' });
      }

      this.form.get('subCategoryId').updateValueAndValidity();
    }

    this.form.updateValueAndValidity();
  }

  onDistanceAmountInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Remove any decimal point and following digits
    if (value.includes('.')) {
      const wholeNumber = value.split('.')[0];
      input.value = wholeNumber;
      this.form.get('distanceAmount').setValue(wholeNumber ? parseInt(wholeNumber, 10) : null);
    }
  }

  amountValidator(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value;
    if (value === undefined || value === null || value === '') {
      return { required: true };
    }

    const amount = +control.value;
    if (amount > 0) {
      return null;
    }

    return { invalid: true };
  }

  onCancelEditing() {
    this.resetFxFields();
    this.hide();
  }

  /**
   * Actioned when the user clicks on the add image button, it forces the browsers browse files window to open
   */
  onAddImage() {
    this.uploadImageInput.nativeElement.click();
  }

  onRemoveImage(index: number) {
    this.removePhotoAtIndex = index;
    this.removePhotoModal.show();
  }

  onConfirmRemoveImage() {
    if (this.removePhotoAtIndex != null) {
      let tmpAttachments = [];
      this.uploadedImageFilenames = [];
      this.uploadImageInput.nativeElement.value = '';

      let i = 0;
      for (let attachment of this.attachments) {
        if (i !== this.removePhotoAtIndex) {
          tmpAttachments.push(attachment);
          this.uploadedImageFilenames.push(attachment.filename);
        }

        i++;
      }

      this.attachments = tmpAttachments;
      this.removePhotoAtIndex = null;
    }

    this.removePhotoModal.hide();
  }

  private isFileTypeAllowed(file: File): boolean {
    const allowedTypes = /(image\/(jpeg|png|gif))|(application\/pdf)/;
    return allowedTypes.test(file.type);
  }

  /**
   * Actioned when the user selects an image to upload and handles grabbing the data for the image preview
   * @param files
   */
  preview(files) {
    if (files.length === 0)
      return;

    if (!this.isFileTypeAllowed(files[0]))
      return;

    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      this.attachments.push({
        data: files[0],
        filename: files[0].name,
        fileUrl: reader.result,
        extension: StringHelper.getFileExtension(files[0].name)
      });
    };
  }

  /**
   * Initiates the call to create the expense claim
   * @param imageFilenames
   */
  actionCreateExpenseClaim(imageFilenames: string[] = []) {
    const dto = {
      visitId: this.form.get('visitId').value,
      expenseCategoryId: this.form.get('categoryId').value,
      currency: this.form.get('currency').value,
      amount: this.form.get('amount').value,
      amountBC: this.transformedFxRateForm.get('transformedAmount').value,
      distanceUnit: this.form.get('distanceUnit').value,
      distanceAmount: this.form.get('distanceAmount').value,
      notes: this.form.get('notes').value,
      subCategory: this.form.get('subCategoryId').value,
      imageFilenames: imageFilenames,
      fullyReconciled: this.form.get('fullyReconciled').value,
      claimFormId: this.form.get('claimFormId').value,
      claimFormUrl: this.form.get('claimFormUrl').value,
      claimFormDate: this.form.get('claimFormDate').value !== null ? moment(this.form.get('claimFormDate').value).format('DD/MMM/yyyy') : null,
      onHold: this.form.get('onHold').value,
      overspendApproved: this.form.get('overspendApproved').value,
      paymentMethod: +this.paymentMethodSelect.selectedValue,
      overridePreloadPaymentMethod: this.overridePreloadPaymentMethod
    };

    this.expenseService.createExpenseClaim(this.form.get('patientId').value, dto).subscribe({
      next: () => {
        this.isFormProcessing = false;
        this.cloned.emit();
        this.resetFxFields();
        this.hide();
      },
      error: error => {
        LogHelper.log(error);
        if (error?.error?.data?.errorCode === 'PRELOAD_BANK_PAYMENT')
        {
          this.isFormProcessing = false;
          this.preloadConfirmModal.show();
        }
        else
        {
          this.alertService.showErrorAlert(error);
          this.isFormProcessing = false;
        }
      }
    });
  }

  confirmPreloadCardOverride() {
    this.overridePreloadPaymentMethod = true;
    this.preloadConfirmModal.hide();
    this.paymentMethodSelect.setValue(ExpenseClaimPaymentMethod.CaxtonCard.toString());
    this.form.patchValue({ paymentMethod: ExpenseClaimPaymentMethod.CaxtonCard });
    this.onFormSubmit();
  }

  /**
   * Called when user wants to see amount in transformed FX currency.
   */
  onShowTransformedFxRate() {
    let amount = this.form.get('amount').value;
    let currency = this.form.get('currency').value;
    let toCurrency = this.baseCurrency;

    if (!this.canTransformRate) {
      this.showFxTransformError = true;
      return;
    }
    this.transformedCurrencyProcessing = true;

    let request = {
      fromCurrencyCode: currency,
      toCurrencyCode: toCurrency,
      quotedAmount: amount
    } as ExchangeRateRequest

    this.exchangeRateService.getTransformedFxRate(request).subscribe({
      next: result => {
        this.transformedCurrencyProcessing = false;
        if (result.result !== null) {
          this.transformedFxRateForm.patchValue({ transformedAmount: result.result });

        }
        else if (result.destinationCurrencyNotAvailable) {
          this.alertService.showWarningAlert(`FX rate information is not available for the base currency set on connected trial (${toCurrency}).`);
        }
        else if (result.sourceCurrencyNotAvailable) {
          this.alertService.showWarningAlert(`FX rate information is not available for this currency (${currency})`);
        }
      },
      error: error => {
        this.transformedCurrencyProcessing = false;
        this.showFxTransformError = true;
        LogHelper.log(error);
        this.alertService.showWarningAlert('Unable to retrieve transformed FX rate!');
      }
    });
  }

  resetFxFields() {
    this.transformedCurrencyProcessing = false;
    this.showFxTransformError = false;

    this.transformedFxRateForm = new UntypedFormGroup({
      transformedAmount: new UntypedFormControl(''),
      transformedCurrency: new UntypedFormControl({ value: '', disabled: true }),
    });
  }

  /**
   * Called when the create expense form is submitted by the user
   */
  onFormSubmit() {
    if (!this.form.valid)
      return;

    this.isFormProcessing = true;

    if (this.imagesUploadedSubscription == null) {
      this.imagesUploadedSubscription = this.imageUploadedEvent.subscribe(imageFilenames => {
        // Check if the number of imageFilenames (uploaded files) matches the number of attachments that needed to be uploaded
        if (imageFilenames.length === this.attachments.length) {
          this.actionCreateExpenseClaim(imageFilenames);
        }
      }, error => {
        LogHelper.log(error);
      });
    }

    // if there are no attachments create the expense claim and exit the function
    if (this.attachments.length === 0) {
      this.actionCreateExpenseClaim();
      return;
    }

    // Upload each attachment one by one. When each attachment is complete, make a call to an event emitter with an array
    // that contains a list of all uploaded filenames so far. A subscriber will monitor the number of uploaded files
    // and when it matches the number of files there were to be uploaded, it will make a call to create the expense claim
    this.uploadedImageFilenames = [];
    for (let attachment of this.attachments) {
      this.expenseService.upload(attachment.data).subscribe({
        next: (rsp: any) => {
          LogHelper.log(rsp);

          if (rsp.success) {
            this.uploadedImageFilenames.push(rsp.fileName);
            this.imageUploadedEvent.emit(this.uploadedImageFilenames);
          } else {
            this.alertService.showWarningAlert('Sorry, there was a problem uploading one of your images.');
            this.imagesUploadedSubscription = null;
          }
        },
        error: (error) => {
          LogHelper.log(error);
          this.alertService.showWarningAlert("Upload failed. Supported file types are images and PDFs.");
          this.isFormProcessing = false;
        }
      });
    }
  }

  private prepareAmountBCControl() {
    if (this.selectedCategory !== null && this.selectedCategory.type === 'Value') {
      if (this.amountQuotedBCControl !== undefined && this.amountQuotedBCControl !== null && this.patient.trialBaseCurrency !== null) {
        this.amountQuotedBCControl.setCurrency(this.baseCurrency);
      }
    }
  }

  /**
   * Loads the patients details and then loads categories/visits for the patients trial
   * @param patientId
   */
  private loadPatientDetails(patientId: string) {
    this.patientService.retrievePatientDetail(patientId).subscribe({
      next: (patient) => {
        this.patient = patient;

        this.form.patchValue({
          patientId: patient.id,
          patientName: patient.firstname + ' ' + patient.lastname,
        });
      },
      error: (error) => {
        LogHelper.log(error);
        this.alertService.showErrorAlert(error);
      }
    });
  }

  private loadPatientTrial(patientId: string, trialId: string): Promise<void> {
    if (!patientId || !trialId)
      return;

    if (this.visitSelect)
      this.visitSelect.loading = true;


    return new Promise((resolve, reject) => {
      this.patientService.getTrialForPatient(patientId, trialId).subscribe({
        next: trial => {
          this.trial = trial;
          this.trialAutocomplete.setInitialValue(trial.id, trial.code);
          this.categories = trial.categories;
          this.baseCurrency = trial.baseCurrency;

          this.categoryOptions = [];
          for (const category of trial.categories) {
            this.categoryOptions.push({ value: category.id, text: category.name });
          }

          if (trial.categories.length === 0) {
            this.categoryOptions.push({ value: '', text: 'No categories' });
          }

          //this.loadPatientVisits(this.form.value.patientId, trialId);

          resolve();
        },
        error: error => {
          LogHelper.log(error);
          this.alertService.showErrorAlert(error);
          reject(error);
        }
      });
    });
  }

  // Load patients visits
  private loadPatientVisits(patientId: string, trialId: string): Promise<void> {
    if (this.visitSelect)
      this.visitSelect.loading = true;

    return new Promise((resolve) => {
      this.patientService.retrievePatientVisitsForTrial(patientId, trialId).subscribe(visits => {
        this.allVisitOptions = [];
        this.showNonVisits = false;
        for (const visit of visits) {
          this.allVisitOptions.push({ value: visit.id, text: visit.visitDateAndTitle(), meta: { nonVisit: visit.nonVisit } });
        }
        this.filterVisitOptions();

        if (this.visitOptions.length === 0) {
          this.visitOptions.push({ value: '', text: 'No visits' });
        }

        if (this.visitSelect)
          this.visitSelect.loading = false;

        resolve();
      });
    });
  }

}
